export default (theme) => ({
    root: {
        height: 'calc(100% - 50px)',
    },
    scroll: {
        padding: '15px 30px',
        height: '100%',
        overflow: 'auto',
        ...theme.utils.scrollbar,
    },
});
